var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recent-dynamic"},_vm._l((_vm.dynamicList),function(d,i){return _c('FeedListItem',{key:'dynamic-' + d.id + '-' + i,staticClass:"dynamic-one",attrs:{"info":d,"boutiqueList":_vm.boutiqueList}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }